module.exports = __webpack_public_path__ + "static/media/ic_launcher.384cf107.png";